import { GRBooking } from './../Model/GRBooking';
import { environment } from './../../environments/environment';
import { Injectable, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Trpconsignment } from '../Model/Trpconsignment';
import { Trpconsignmentinv } from '../Model/Trpconsignmentinv';
import { ConsignmentDelivery } from '../Model/ConsignmentDelivery';
import { GRBill } from '../Model/GRBill';
import { BulkDeliveryInput } from '../Model/BulkDeliveryInput';

@Injectable( {
  providedIn: 'root'
} )
export class GRbookingervice
{

  constructor ( private _httpClient: HttpClient ) { }

  GETMaxGRNO ( input: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbookingHelper/" + input, httpOptions );
  }

  GETMaxInvoiceNO (): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbookingInvoiceHelper", httpOptions );
  }

  GETInvoiceBYGRNO ( input: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbookingInvoice/" + input, httpOptions );
  }

  AddGRDetail ( input: Trpconsignment ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "grbooking", body, httpOptions );
  }

  SubmitGRDetail ( input: GRBooking ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "grbooking", body, httpOptions );
  }


  DeleteGR ( CN_NO: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "grbooking?CNNO=" + CN_NO + "&iUserId=" + iUserId, httpOptions );
  }

  UpdateConsignment ( input: GRBooking ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.put( environment.WebserviceUrl + "grbooking", body, httpOptions );
  }

  AddInvoiceDetail ( input: Trpconsignmentinv ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "grbookingInvoice", body, httpOptions );
  }

  DeleteInvoice ( input: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "grbookingInvoice/" + input, httpOptions );
  }

  SearchGRList ( iType: number, SearchbyId: number, Searchvalue: string, floc: number, tloc: number, startdate: string, enddate: string, userid: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbooking?iType=" + iType + "&SearchbyId=" + SearchbyId + "&Searchvalue=" + Searchvalue + "&floc=" + floc + "&tloc=" + tloc + "&startdate=" + startdate + "&enddate=" + enddate + "&userid=" + userid, httpOptions );
  }



  GETGRLIST ( iType: number, floc: number, tloc: number, CNStatus: string, userid: number, optionalparameter: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    //console.log(environment.WebserviceUrl + "grbooking?iType=" + iType + "&floc=" + floc + "&tloc=" + tloc + "&CNStatus=" + CNStatus + "&optionalparameter=" + optionalparameter);
    return this._httpClient.get( environment.WebserviceUrl + "grbooking?iType=" + iType + "&floc=" + floc + "&tloc=" + tloc + "&CNStatus=" + CNStatus + "&userid=" + userid + "&optionalparameter=" + optionalparameter, httpOptions );
  }

  SearchGR ( searchby: number, searchvalue: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbookingHelper?searchby=" + searchby + "&searchByValue=" + searchvalue, httpOptions );
  }

  GetBillers (): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "biller", httpOptions );
  }

  GETGRDetail ( cnid: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbooking?cnid=" + cnid, httpOptions );
  }

  GETGRDetailByCnoOrRefNo ( cnid: string, refid: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbooking?cnid=" + cnid + "&refid=" + refid, httpOptions );
  }

  GETGRBYCN_NO ( iType: number, cnid: string, iLocId: number )
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbooking?iType=" + iType + "&cnid=" + cnid + "&iLocId=" + iLocId, httpOptions );
  }

  GETGRFORDDL ( iType: number, iLocId: number, sAccCode: string )
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbooking?iType=" + iType + "&iLocId=" + iLocId + "&sAccCode=" + sAccCode, httpOptions );
  }

  GrDeliveryUpdate ( input: ConsignmentDelivery ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "ConsignmentDelivery", body, httpOptions );
  }

  UpdatePodStats ( input: Trpconsignment ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "grbookingHelper", body, httpOptions );
  }

  GETGRUPDATEHISTORY ( cnno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "GrUpdateHistory?cnno=" + cnno, httpOptions );
  }

  //============================================Bill Generation=======================================
  AddGRBill ( input: GRBill ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "BillGeneration", body, httpOptions );
  }

  UpdateBILL ( input: GRBill ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.put( environment.WebserviceUrl + "BillGeneration", body, httpOptions );
  }

  GETBILLLIST ( intype: number, iLocId: number, userid: number, billpartycode: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "BillGeneration?intype=" + intype + "&ilocid=" + iLocId + "&userid=" + userid + "&billpartycode=" + billpartycode, httpOptions );
  }

  GETBILLDetail ( id: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "BillGeneration/" + id, httpOptions );
  }

  GETBILLGRDetail ( intype: number, sbillno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "BillGenerationDetail?intype=" + intype + "&sbillno=" + sbillno, httpOptions );
  }

  GETGRNOLIST ( intype: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbookingHelper?intype=" + intype, httpOptions );
  }


  GETGLISTBYDATEFORPRINT ( sdoctype: string, intype: number, fromdate: string, todate: string, locid: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "DocumentPrint?sdoctype=" + sdoctype + "&intype=" + intype + "&fromdate=" + fromdate + "&todate=" + todate + "&locid=" + locid, httpOptions );
  }

  GETGETDDRCHARTNO ( intype: number, startdate: string, enddate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbookingHelper?intype=" + intype + "&startdate=" + startdate + "&enddate=" + enddate, httpOptions );
  }

  GETBillDetailByGRNo ( cnno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "BillGenerationHelper?cnno=" + cnno, httpOptions );
  }

  DeleteBill ( billno: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.delete( environment.WebserviceUrl + "BillGeneration?billno=" + billno + "&iUserId=" + iUserId, httpOptions );
  }


  //-------------------------------File Upload Master---------------------------------------------------------------------
  PostFile ( fileToUpload: File, RequestFrom: string, FileName: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    const httpOptions = { headers };
    const formData: FormData = new FormData();
    formData.append( 'RequestFrom', RequestFrom );
    formData.append( 'PersonalFile', fileToUpload, FileName );
    return this._httpClient.post( environment.WebserviceUrl + "APISaveImage", formData, httpOptions );
  }

  //---------------------------Dashboard---------------------------------------
  GetDashboardData ( userid: number, grdate: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "Dashboard?userid=" + userid + "&grdate=" + grdate, httpOptions );
  }

  GETPODStatus ( cnno: string ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "PODStatus?cnno=" + cnno, httpOptions );
  }

  GrDeliveryUpdatebulk ( input: BulkDeliveryInput ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "BulkDelivery", body, httpOptions );
  }

  UpdateDeliveryInterest ( cnno: string, idelveryInterest: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "grbooking/UpdateDeliveryInterest?cnno=" + cnno + "&idelveryInterest=" + idelveryInterest + "&iUserId=" + iUserId, httpOptions );
  }
  GetGRBokkingPerformance ( fdate: string, tdate: string, iUserId: number ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    return this._httpClient.get( environment.WebserviceUrl + "Report/GetBookingPerformance?fdate=" + fdate + "&tdate=" + tdate + "&iUserId=" + iUserId, httpOptions );
  }

  SubmitWebGR ( input: GRBooking ): Observable<any>
  {
    let headers = new HttpHeaders();
    headers = headers.append( "Authorization", "Bearer " + environment.token );
    headers = headers.append( "Content-Type", "application/json" );
    const httpOptions = { headers };
    let body = JSON.stringify( input );
    return this._httpClient.post( environment.WebserviceUrl + "grbookingweb/partygrbooking", body, httpOptions );
  }
}
